import { Component, Watch } from 'vue-property-decorator'

import { Item, Location as LocationEntity, SearchResult, getTranslatedString } from '@skinsoft/types'
import { itemSelectors, locationSelectors } from '@skinsoft/selectors'
import { LocationDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { searchResultSelectors } from '@skinsoft/search-data-store'

@Component({
    props: ['item', 'displayPath', 'dataCy', 'itemType'],
    template: require('./location.html'),
})
export class Location extends ReactiveVue {
    public item: Item | SearchResult
    public displayPath: boolean;
    public itemType: 'SearchResult' | 'Item'

    public $locationDataStore: LocationDataStore;
    public locationSelectors = locationSelectors;
    public location: LocationEntity = null as any;
    private locationTitle: string = ""
    private fullPathLocation: string = "";
    private firstSynonym: string = "";
    private isPermanent: boolean = false;

    public created() {
        this.subscribe();
    }

    private subscribe() {
        switch(this.itemType) {
            case 'Item':
                let locationId = itemSelectors.realTimeLocation(this.item as Item)

                // Taking permanent location if no real-time one is available
                if (!locationId) {
                    locationId = itemSelectors.permanentLocation(this.item as Item);
                    this.isPermanent = true;
                }

                if (!locationId) {
                    this.$emit('ready');
                    return;
                }

                this.subscribeTo(
                    this.$locationDataStore.fetchOne(locationId),
                    async location => {
                        this.$emit('ready');
                        this.location = location;
                        this.locationTitle = locationSelectors.translatedTitle(location, this.$i18n.locale)

                        this.fullPathLocation = await this.$locationDataStore.resolvePath(
                            locationSelectors.pathIds(location), 
                            this.$i18n.locale
                        )

                        this.firstSynonym = locationSelectors.firstSynonym(location, this.$i18n.locale)
                    },
                    'location',
                );
                break

            case 'SearchResult':
                this.location = searchResultSelectors.realTimeLocation(this.item as SearchResult)
                if(!this.location) {
                    this.isPermanent = true
                    this.location = searchResultSelectors.permanentLocation(this.item as SearchResult)
                    if(!this.location) {
                        this.$emit('ready')
                        return
                    }
                }
                this.locationTitle = getTranslatedString((this.location as any).value, this.$i18n.locale)
                this.fullPathLocation = getTranslatedString((this.location as any).path, this.$i18n.locale)
                this.$emit('ready')
                break
        }
    }

    @Watch('item')
    private onItemChange() {
        this.isPermanent = false;
        this.unsubscribeFrom('location');
        this.subscribe();
    }
}
